module.exports = __webpack_public_path__ + "img/dr_4.eae8fc39.png";